var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIconTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94922 23.6837C7.94922 23.3537 8.20922 22.9937 8.62797 22.9937H10.9367C12.2367 22.9937 13.4067 23.8637 13.4067 25.5312C13.4067 27.1112 12.2367 27.9912 10.9367 27.9912H9.26797V29.3112C9.26797 29.7512 8.98797 30 8.62797 30C8.29797 30 7.94922 29.7512 7.94922 29.3112V23.6837ZM9.26797 24.2525V26.7425H10.9367C11.6067 26.7425 12.1367 26.1512 12.1367 25.5312C12.1367 24.8325 11.6067 24.2525 10.9367 24.2525H9.26797ZM15.3642 30C15.0342 30 14.6742 29.82 14.6742 29.3812V23.7037C14.6742 23.345 15.0342 23.0837 15.3642 23.0837H17.653C22.2205 23.0837 22.1205 30 17.743 30H15.3642ZM15.9942 24.3037V28.7812H17.653C20.3517 28.7812 20.4717 24.3037 17.653 24.3037H15.9942ZM23.7405 24.3837V25.9725H26.2892C26.6492 25.9725 27.0092 26.3325 27.0092 26.6812C27.0092 27.0112 26.6492 27.2812 26.2892 27.2812H23.7405V29.38C23.7405 29.73 23.4917 29.9987 23.1417 29.9987C22.7017 29.9987 22.433 29.73 22.433 29.38V23.7025C22.433 23.3437 22.703 23.0825 23.1417 23.0825H26.6505C27.0905 23.0825 27.3505 23.3437 27.3505 23.7025C27.3505 24.0225 27.0905 24.3825 26.6505 24.3825H23.7405V24.3837Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIconTable);
export default __webpack_public_path__ + "static/media/pdf-icon-table.62e1f555c058f5fc1c53ad91f5a01109.svg";
export { ForwardRef as ReactComponent };